/* Notre Histoire : gravure laser en direct sur les vrais bijoux de la boutique (page d'accueil) */
(function () {
'use strict';
var root = document.querySelector('[data-nh-laser]');
if (!root || root._nh) return;
root._nh = 1;
var stage = root.querySelector('.nh-lz-stage');
var cv = root.querySelector('.nh-lz-cv');
var ctx = cv.getContext('2d');
var capEl = root.querySelector('[data-nh-lz-cap]');
var dotsEl = root.querySelector('[data-nh-lz-dots]');
var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
var ITEMS = [];
try { ITEMS = JSON.parse(root.querySelector('script[type="application/json"]').textContent) || []; } catch (e) {}
ITEMS = ITEMS.filter(function (p) { return p && p.img && p.box && p.iw && p.ih; });
if (!ITEMS.length) return;

var W = 0, H = 0, dpr = 1;
var cur = -1, job = null, nextIdx = -1, sparks = [];
var running = false, raf = 0, last = 0, visible = true, booted = false;

function mk(w, h) { var c = document.createElement('canvas'); c.width = w; c.height = h; return c; }

function size() {
  var r = stage.getBoundingClientRect();
  if (!r.width) return;
  dpr = Math.min(window.devicePixelRatio || 1, 2);
  W = r.width; H = r.height;
  cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
}

/* zone de la photo a afficher : la medaille au centre, la chaine au-dessus */
function cropFor(p) {
  var b = p.box, mw = (b[2] - b[0]) * p.iw, mh = (b[3] - b[1]) * p.ih;
  var cw = Math.max(mw / 0.5, mh / 0.6 * 5 / 6), ch = cw * 1.2;
  cw = Math.min(cw, p.iw, p.ih / 1.2); ch = cw * 1.2;
  var cx = (b[0] + b[2]) / 2 * p.iw, cy = (b[1] + b[3]) / 2 * p.ih;
  var l = Math.round(Math.min(Math.max(0, cx - cw / 2), p.iw - cw));
  var t = Math.round(Math.min(Math.max(0, cy - 0.55 * ch), p.ih - ch));
  return { l: l, t: t, w: Math.round(cw), h: Math.round(ch) };
}

function load(i) {
  var p = ITEMS[i];
  if (p._job) return p._job;
  p._job = new Promise(function (res) {
    var c = cropFor(p);
    var ow = Math.max(420, Math.min(1000, Math.round((W || 420) * dpr))), oh = Math.round(ow * 1.2);
    var base = p.img.split('?')[0]; if (base.indexOf('//') === 0) base = 'https:' + base;
    var url = base + '?width=' + ow + '&height=' + oh + '&crop=region&crop_left=' + c.l + '&crop_top=' + c.t + '&crop_width=' + c.w + '&crop_height=' + c.h;
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () { var j = null; try { j = prep(p, img, c); } catch (e) { j = null; } if (!j) p._job = null; res(j); };
    img.onerror = function () { p._job = null; res(null); };
    img.src = url;
  });
  return p._job;
}

/* repere la gravure sur la photo, l'efface (version "avant laser") et prepare le trajet du laser */
function prep(p, img, c) {
  var iw = img.naturalWidth, ih = img.naturalHeight;
  if (!iw || !ih) return null;
  var orig = mk(iw, ih), oc = orig.getContext('2d');
  oc.drawImage(img, 0, 0, iw, ih);
  var j = { p: p, orig: orig, blank: orig, iw: iw, ih: ih, path: [], rows: [], hot: null, medal: null, bx: 0, by: 0, total: 0 };
  var sx = iw / c.w, sy = ih / c.h;
  var bw0 = (p.box[2] - p.box[0]) * p.iw * sx, bh0 = (p.box[3] - p.box[1]) * p.ih * sy;
  var x0 = Math.max(1, Math.floor((p.box[0] * p.iw - c.l) * sx - bw0 * 0.07));
  var y0 = Math.max(1, Math.floor((p.box[1] * p.ih - c.t) * sy - bh0 * 0.07));
  var x1 = Math.min(iw - 1, Math.ceil((p.box[2] * p.iw - c.l) * sx + bw0 * 0.07));
  var y1 = Math.min(ih - 1, Math.ceil((p.box[3] * p.ih - c.t) * sy + bh0 * 0.07));
  var w = x1 - x0, h = y1 - y0, n = w * h;
  if (w < 20 || h < 20) return j;
  var id;
  try { id = oc.getImageData(x0, y0, w, h); } catch (e) { return j; }
  var d = id.data, L = new Uint8Array(n), out = new Uint8Array(n), core = new Uint8Array(n), ink = new Uint8Array(n);
  var k, r, g, b;
  for (k = 0; k < n; k++) { r = d[k * 4]; g = d[k * 4 + 1]; b = d[k * 4 + 2]; L[k] = (r * 299 + g * 587 + b * 114) / 1000; }
  /* fond (bleu nuit) : tout ce qui est sombre et relie au bord de la zone */
  var st = new Int32Array(n), sp = 0, x, y;
  function push(q) { if (!out[q] && L[q] < 90) { out[q] = 1; st[sp++] = q; } }
  for (x = 0; x < w; x++) { push(x); push((h - 1) * w + x); }
  for (y = 0; y < h; y++) { push(y * w); push(y * w + w - 1); }
  while (sp) {
    k = st[--sp]; x = k % w; y = (k - x) / w;
    if (x > 0) push(k - 1); if (x < w - 1) push(k + 1); if (y > 0) push(k - w); if (y < h - 1) push(k + w);
  }
  var cnt = 0, inside = 0;
  for (k = 0; k < n; k++) {
    if (out[k]) continue;
    inside++;
    r = d[k * 4]; g = d[k * 4 + 1]; b = d[k * 4 + 2];
    if (L[k] < 82 && b - (r + g) / 2 < 10) { core[k] = 1; cnt++; }
  }
  if (cnt < inside * 0.01 || cnt > inside * 0.5) return j;
  /* elargit de 2 px pour prendre le bord adouci des traits */
  var rad = Math.max(2, Math.round(w / 95));
  for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
    k = y * w + x; if (!core[k]) continue;
    for (var dy = -rad; dy <= rad; dy++) { var yy = y + dy; if (yy < 0 || yy >= h) continue;
      for (var dx = -rad; dx <= rad; dx++) { var xx = x + dx; if (xx < 0 || xx >= w) continue; var q = yy * w + xx; if (!out[q]) ink[q] = 1; } }
  }
  /* efface la gravure : remplissage doux a partir du metal autour (push-pull) */
  var R0 = new Float32Array(n), G0 = new Float32Array(n), B0 = new Float32Array(n), W0 = new Float32Array(n);
  for (k = 0; k < n; k++) { if (!ink[k] && !out[k]) { R0[k] = d[k * 4]; G0[k] = d[k * 4 + 1]; B0[k] = d[k * 4 + 2]; W0[k] = 1; } }
  pushPull(R0, G0, B0, W0, w, h);
  var bd = new ImageData(new Uint8ClampedArray(d), w, h), bdd = bd.data;
  for (k = 0; k < n; k++) if (ink[k]) { var nz = (Math.random() - 0.5) * 3; bdd[k * 4] = R0[k] + nz; bdd[k * 4 + 1] = G0[k] + nz; bdd[k * 4 + 2] = B0[k] + nz; }
  var blank = mk(iw, ih), bc = blank.getContext('2d');
  bc.drawImage(orig, 0, 0); bc.putImageData(bd, x0, y0);
  /* calque "metal chaud" (traits orange) et masque de la medaille pour le reflet */
  var hot = mk(w, h), hc = hot.getContext('2d'), hd = hc.createImageData(w, h), hdd = hd.data;
  var med = mk(w, h), mc = med.getContext('2d'), md = mc.createImageData(w, h), mdd = md.data;
  for (k = 0; k < n; k++) {
    if (ink[k]) { var a = Math.max(0, Math.min(1, (120 - L[k]) / 70)); hdd[k * 4] = 255; hdd[k * 4 + 1] = 168; hdd[k * 4 + 2] = 72; hdd[k * 4 + 3] = a * 255; }
    if (!out[k]) { mdd[k * 4 + 3] = 255; }
  }
  hc.putImageData(hd, 0, 0); mc.putImageData(md, 0, 0);
  /* trajet du laser : lignes horizontales, en aller-retour, uniquement sur les traits */
  var ix0 = w, ix1 = 0, iy0 = h, iy1 = 0;
  for (y = 0; y < h; y++) for (x = 0; x < w; x++) if (ink[y * w + x]) { if (x < ix0) ix0 = x; if (x > ix1) ix1 = x; if (y < iy0) iy0 = y; if (y > iy1) iy1 = y; }
  var rh = Math.max(3, Math.round((iy1 - iy0 + 1) / 30)), rows = [], path = [], total = 0, dir = 1;
  for (var ry = iy0; ry <= iy1; ry += rh) {
    var segs = [], on = false, s0 = 0, gapMin = rh;
    for (x = ix0; x <= ix1 + 1; x++) {
      var hit = false;
      if (x <= ix1) for (y = ry; y < Math.min(ry + rh, h); y++) if (ink[y * w + x]) { hit = true; break; }
      if (hit && !on) { on = true; s0 = x; }
      if (!hit && on) { on = false; if (segs.length && s0 - segs[segs.length - 1][1] < gapMin) segs[segs.length - 1][1] = x; else segs.push([s0, x]); }
    }
    if (!segs.length) continue;
    var row = { y0: ry + y0, y1: Math.min(ry + rh, h) + y0, a: segs[0][0] + x0, b: segs[segs.length - 1][1] + x0, dir: dir };
    if (dir < 0) segs.reverse();
    segs.forEach(function (sg) {
      var from = dir > 0 ? sg[0] : sg[1], to = dir > 0 ? sg[1] : sg[0];
      path.push({ row: rows.length, from: from + x0, to: to + x0, len: Math.abs(to - from) });
      total += Math.abs(to - from);
    });
    rows.push(row); dir = -dir;
  }
  j.blank = blank; j.hot = hot; j.medal = med; j.bx = x0; j.by = y0; j.bw = w; j.bh = h;
  j.rows = rows; j.path = path; j.total = total;
  return j;
}

function pushPull(R, G, B, Wt, w, h) {
  var lv = [{ R: R, G: G, B: B, W: Wt, w: w, h: h }];
  while (w > 1 || h > 1) {
    var nw = Math.ceil(w / 2), nh = Math.ceil(h / 2), nn = nw * nh;
    var nR = new Float32Array(nn), nG = new Float32Array(nn), nB = new Float32Array(nn), nW = new Float32Array(nn);
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
      var k = y * w + x, wt = Wt[k]; if (!wt) continue;
      var q = (y >> 1) * nw + (x >> 1);
      nR[q] += R[k] * wt; nG[q] += G[k] * wt; nB[q] += B[k] * wt; nW[q] += wt;
    }
    for (var q2 = 0; q2 < nn; q2++) if (nW[q2] > 0) { nR[q2] /= nW[q2]; nG[q2] /= nW[q2]; nB[q2] /= nW[q2]; nW[q2] = Math.min(1, nW[q2]); }
    R = nR; G = nG; B = nB; Wt = nW; w = nw; h = nh;
    lv.push({ R: R, G: G, B: B, W: Wt, w: w, h: h });
  }
  for (var i = lv.length - 2; i >= 0; i--) {
    var a = lv[i], c = lv[i + 1];
    for (var yy = 0; yy < a.h; yy++) for (var xx = 0; xx < a.w; xx++) {
      var kk = yy * a.w + xx, t = a.W[kk]; if (t >= 1) continue;
      var fx = Math.min(c.w - 1, Math.max(0, (xx + 0.5) / 2 - 0.5)), fy = Math.min(c.h - 1, Math.max(0, (yy + 0.5) / 2 - 0.5));
      var x0 = Math.floor(fx), y0 = Math.floor(fy), x1 = Math.min(c.w - 1, x0 + 1), y1 = Math.min(c.h - 1, y0 + 1), ax = fx - x0, ay = fy - y0;
      var k00 = y0 * c.w + x0, k10 = y0 * c.w + x1, k01 = y1 * c.w + x0, k11 = y1 * c.w + x1;
      var w00 = (1 - ax) * (1 - ay), w10 = ax * (1 - ay), w01 = (1 - ax) * ay, w11 = ax * ay;
      a.R[kk] = a.R[kk] * t + (c.R[k00] * w00 + c.R[k10] * w10 + c.R[k01] * w01 + c.R[k11] * w11) * (1 - t);
      a.G[kk] = a.G[kk] * t + (c.G[k00] * w00 + c.G[k10] * w10 + c.G[k01] * w01 + c.G[k11] * w11) * (1 - t);
      a.B[kk] = a.B[kk] * t + (c.B[k00] * w00 + c.B[k10] * w10 + c.B[k01] * w01 + c.B[k11] * w11) * (1 - t);
      a.W[kk] = 1;
    }
  }
}

/* ---------- affichage ---------- */
function setCaption(p) {
  if (stage.tagName === 'A') { stage.href = p.u; stage.setAttribute('aria-label', 'Voir ' + p.t); }
  if (capEl) {
    capEl.innerHTML = '';
    var t = document.createElement('span'); t.textContent = p.t + (p.price ? ' · ' + p.price : '') + ' ';
    var a = document.createElement('a'); a.href = p.u; a.textContent = 'Voir ce bijou →';
    capEl.appendChild(t); capEl.appendChild(a);
  }
  if (dotsEl) [].forEach.call(dotsEl.children, function (b, i) { b.setAttribute('aria-current', i === cur ? 'true' : 'false'); });
}

function begin(i, j) {
  cur = i; job = j;
  j.phase = reduce ? 'hold' : 'intro'; j.t = 0; j.seg = 0; j.pos = j.path.length ? j.path[0].from : 0; j.alpha = 0;
  j.speed = j.total / 3.8; j.next = null;
  setCaption(j.p);
  nextIdx = (i + 1) % ITEMS.length;
  if (ITEMS.length > 1) load(nextIdx);
}

function rowRevealed(j, r) {
  /* portion revelee de la ligne r : [a,b] en pixels image, ou null */
  var row = j.rows[r];
  if (j.phase !== 'engrave') return j.phase === 'intro' ? null : [row.a, row.b];
  var cs = j.path[j.seg]; if (!cs) return [row.a, row.b];
  if (r < cs.row) return [row.a, row.b];
  if (r > cs.row) return null;
  return row.dir > 0 ? [row.a, Math.max(row.a, j.pos)] : [Math.min(row.b, j.pos), row.b];
}

function drawScene(j, alpha) {
  var sx = W / j.iw, sy = H / j.ih;
  ctx.globalAlpha = alpha;
  ctx.drawImage(j.blank, 0, 0, W, H);
  for (var r = 0; r < j.rows.length; r++) {
    var rv = rowRevealed(j, r); if (!rv) break;
    var row = j.rows[r], a = Math.max(0, rv[0] - 1), b = Math.min(j.iw, rv[1] + 1);
    if (b - a < 1) continue;
    ctx.drawImage(j.orig, a, row.y0, b - a, row.y1 - row.y0, a * sx, row.y0 * sy, (b - a) * sx, (row.y1 - row.y0) * sy);
  }
  if (j.phase === 'engrave' && j.hot) {
    var cs = j.path[j.seg];
    if (cs) {
      var row2 = j.rows[cs.row], trail = j.bw * 0.22, ha = row2.dir > 0 ? j.pos - trail : j.pos, hb = row2.dir > 0 ? j.pos : j.pos + trail;
      ha = Math.max(row2.a, ha); hb = Math.min(row2.b, hb);
      if (hb > ha) {
        ctx.save(); ctx.globalCompositeOperation = 'lighter'; ctx.globalAlpha = 0.85 * alpha;
        ctx.drawImage(j.hot, ha - j.bx, row2.y0 - j.by, hb - ha, row2.y1 - row2.y0, ha * sx, row2.y0 * sy, (hb - ha) * sx, (row2.y1 - row2.y0) * sy);
        ctx.restore();
      }
      if (cs.row > 0) {
        var pr = j.rows[cs.row - 1];
        ctx.save(); ctx.globalCompositeOperation = 'lighter'; ctx.globalAlpha = 0.3 * alpha;
        ctx.drawImage(j.hot, pr.a - j.bx, pr.y0 - j.by, pr.b - pr.a, pr.y1 - pr.y0, pr.a * sx, pr.y0 * sy, (pr.b - pr.a) * sx, (pr.y1 - pr.y0) * sy);
        ctx.restore();
      }
    }
  }
  ctx.globalAlpha = 1;
}

var sheenC = null;
function drawSheen(j, p) {
  if (!j.medal || p <= 0 || p >= 1) return;
  if (!sheenC || sheenC.width !== j.bw || sheenC.height !== j.bh) sheenC = mk(j.bw, j.bh);
  var c = sheenC.getContext('2d'), w = j.bw, h = j.bh;
  c.globalCompositeOperation = 'source-over'; c.clearRect(0, 0, w, h);
  var x = -w * 0.6 + p * w * 2.2;
  var g = c.createLinearGradient(x - w * 0.25, 0, x + w * 0.25, h * 0.35);
  g.addColorStop(0, 'rgba(255,255,255,0)'); g.addColorStop(0.5, 'rgba(255,250,235,0.75)'); g.addColorStop(1, 'rgba(255,255,255,0)');
  c.fillStyle = g; c.fillRect(0, 0, w, h);
  c.globalCompositeOperation = 'destination-in'; c.drawImage(j.medal, 0, 0);
  var sx = W / j.iw, sy = H / j.ih;
  ctx.save(); ctx.globalCompositeOperation = 'lighter'; ctx.globalAlpha = 0.55;
  ctx.drawImage(sheenC, j.bx * sx, j.by * sy, w * sx, h * sy); ctx.restore();
}

function laserPoint(j, now) {
  if (j.phase !== 'engrave') return null;
  var cs = j.path[j.seg]; if (!cs) return null;
  var row = j.rows[cs.row], sx = W / j.iw, sy = H / j.ih;
  var yy = row.y0 + (row.y1 - row.y0) * (0.5 + 0.4 * Math.sin(now / 17));
  return { x: j.pos * sx, y: yy * sy, on: j.travel ? false : true };
}

function roundRect(x, y, w, h, r) {
  ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath();
}

var headX = -1;
function drawLaser(pt, j) {
  var headY = Math.max(24, H * 0.07);
  var tx = pt ? pt.x : (j && j.path.length && j.phase === 'intro' ? j.path[0].from * W / j.iw : W / 2);
  headX = headX < 0 ? tx : headX + (tx - headX) * (pt ? 1 : 0.12);
  ctx.save();
  ctx.strokeStyle = 'rgba(233,211,160,0.35)'; ctx.lineWidth = 2;
  ctx.beginPath(); ctx.moveTo(W * 0.05, headY - 9); ctx.lineTo(W * 0.95, headY - 9); ctx.stroke();
  ctx.fillStyle = 'rgba(20,10,16,0.92)'; ctx.strokeStyle = 'rgba(233,211,160,0.7)'; ctx.lineWidth = 1;
  roundRect(headX - 18, headY - 18, 36, 16, 4); ctx.fill(); ctx.stroke();
  ctx.fillStyle = pt && pt.on ? '#ff3b3b' : '#6b2a2a';
  ctx.beginPath(); ctx.arc(headX + 11, headY - 10, 2.3, 0, Math.PI * 2); ctx.fill();
  ctx.fillStyle = '#3b2a30'; ctx.fillRect(headX - 3, headY - 2, 6, 5);
  if (pt) {
    ctx.globalCompositeOperation = 'lighter';
    var a = pt.on ? 1 : 0.25;
    var g = ctx.createLinearGradient(headX, headY, pt.x, pt.y);
    g.addColorStop(0, 'rgba(255,90,60,' + 0.12 * a + ')'); g.addColorStop(1, 'rgba(255,120,70,' + 0.7 * a + ')');
    ctx.strokeStyle = g; ctx.lineWidth = 4; ctx.beginPath(); ctx.moveTo(headX, headY + 3); ctx.lineTo(pt.x, pt.y); ctx.stroke();
    ctx.strokeStyle = 'rgba(255,240,220,' + 0.8 * a + ')'; ctx.lineWidth = 1; ctx.beginPath(); ctx.moveTo(headX, headY + 3); ctx.lineTo(pt.x, pt.y); ctx.stroke();
    var rr = Math.max(10, W * 0.045);
    var s = ctx.createRadialGradient(pt.x, pt.y, 0, pt.x, pt.y, rr);
    s.addColorStop(0, 'rgba(255,255,255,' + a + ')'); s.addColorStop(0.25, 'rgba(255,196,110,' + 0.85 * a + ')'); s.addColorStop(1, 'rgba(255,80,40,0)');
    ctx.fillStyle = s; ctx.beginPath(); ctx.arc(pt.x, pt.y, rr, 0, Math.PI * 2); ctx.fill();
  }
  ctx.restore();
}

function spawn(pt, dt) {
  if (!pt || !pt.on) return;
  var nn = Math.min(5, Math.ceil(dt * 220)), sc = W / 400;
  for (var i = 0; i < nn; i++) {
    var ang = -Math.PI / 2 + (Math.random() - 0.5) * 2.6, sp = (60 + Math.random() * 170) * sc;
    sparks.push({ x: pt.x, y: pt.y, vx: Math.cos(ang) * sp, vy: Math.sin(ang) * sp, life: 0.2 + Math.random() * 0.4, age: 0 });
  }
  if (sparks.length > 200) sparks.splice(0, sparks.length - 200);
}
function drawSparks(dt) {
  if (!sparks.length) return;
  var sc = W / 400;
  ctx.save(); ctx.globalCompositeOperation = 'lighter'; ctx.lineCap = 'round';
  for (var i = sparks.length - 1; i >= 0; i--) {
    var s = sparks[i];
    s.age += dt; if (s.age > s.life) { sparks.splice(i, 1); continue; }
    s.vy += 520 * sc * dt; s.x += s.vx * dt; s.y += s.vy * dt;
    var k = 1 - s.age / s.life;
    ctx.strokeStyle = 'rgba(255,' + Math.round(150 + 100 * k) + ',' + Math.round(60 + 120 * k) + ',' + k + ')';
    ctx.lineWidth = 1.3 * k + 0.4;
    ctx.beginPath(); ctx.moveTo(s.x, s.y); ctx.lineTo(s.x - s.vx * 0.02, s.y - s.vy * 0.02); ctx.stroke();
  }
  ctx.restore();
}

function step(dt) {
  var j = job; if (!j) return;
  j.t += dt;
  if (j.phase === 'intro') {
    j.alpha = Math.min(1, j.alpha + dt * 3);
    if (j.t > 0.7) { j.phase = j.path.length ? 'engrave' : 'hold'; j.t = 0; }
  } else if (j.phase === 'engrave') {
    var left = dt * j.speed;
    while (left > 0 && j.seg < j.path.length) {
      var cs = j.path[j.seg], dirn = cs.to >= cs.from ? 1 : -1;
      j.travel = false;
      var remain = Math.abs(cs.to - j.pos);
      if (remain > left) { j.pos += dirn * left; left = 0; break; }
      left -= remain; j.pos = cs.to; j.seg++;
      var nx = j.path[j.seg];
      if (nx) {
        /* deplacement rapide (laser coupe) jusqu'au trait suivant */
        var jump = Math.abs(nx.from - j.pos) + (nx.row !== cs.row ? (j.rows[nx.row].y0 - j.rows[cs.row].y0) : 0);
        left -= jump / 5; j.pos = nx.from; j.travel = true;
      }
    }
    if (j.seg >= j.path.length) { j.phase = 'hold'; j.t = 0; }
  } else if (j.phase === 'hold') {
    var hold = reduce ? 4.5 : 2.8;
    if (j.t > hold && ITEMS.length > 1) {
      var nj = ITEMS[nextIdx]._job;
      if (nj && j.next === null) { j.next = false; nj.then(function (r) { j.next = r || 'skip'; }); }
      if (j.next) {
        if (j.next === 'skip') { nextIdx = (nextIdx + 1) % ITEMS.length; if (nextIdx === cur) { j.t = 0; j.next = null; return; } load(nextIdx); j.next = null; j.t = hold; return; }
        j.phase = 'fade'; j.t = 0;
      } else if (!nj) { load(nextIdx); }
    }
  } else if (j.phase === 'fade') {
    if (j.t > (reduce ? 0.01 : 0.7)) { var nj2 = j.next; begin(nextIdx, nj2); nj2.alpha = 1; nj2.phase = reduce ? 'hold' : 'intro'; nj2.t = 0.35; }
  }
}

function frame(now) {
  raf = 0;
  if (!running) return;
  var dt = Math.min(0.05, (now - (last || now)) / 1000); last = now;
  step(dt);
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  ctx.clearRect(0, 0, W, H);
  var j = job;
  if (j) {
    drawScene(j, 1);
    if (j.phase === 'hold') drawSheen(j, j.t / 1.4);
    if (j.phase === 'fade' && j.next && j.next !== 'skip') {
      ctx.globalAlpha = Math.min(1, j.t / 0.7);
      ctx.drawImage(j.next.blank, 0, 0, W, H);
      ctx.globalAlpha = 1;
    }
    if (!reduce) {
      var pt = laserPoint(j, now);
      spawn(pt, dt);
      drawSparks(dt);
      drawLaser(pt, j);
    }
  }
  raf = requestAnimationFrame(frame);
}

function start() { if (!booted || running || !visible || document.hidden) return; running = true; last = 0; if (!raf) raf = requestAnimationFrame(frame); }
function stop() { running = false; if (raf) cancelAnimationFrame(raf); raf = 0; }

if (dotsEl) {
  ITEMS.forEach(function (p, i) {
    var b = document.createElement('button');
    b.type = 'button'; b.setAttribute('aria-label', p.t);
    b.addEventListener('click', function () {
      if (i === cur) return;
      load(i).then(function (j) { if (j) { sparks = []; begin(i, j); } });
    });
    dotsEl.appendChild(b);
  });
}

if ('IntersectionObserver' in window) {
  new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) start(); else stop(); }, { threshold: 0.05 }).observe(stage);
}
document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
window.addEventListener('resize', size);

size();
(function first(i, tries) {
  load(i).then(function (j) {
    if (j) { booted = true; begin(i, j); start(); }
    else if (tries < ITEMS.length) first((i + 1) % ITEMS.length, tries + 1);
  });
})(0, 1);
})();
